import axios from 'axios'

import { appSettings } from '../../app/settings/app-settings'

import { ExamCard, Task } from 'common/types/entities'

const instance = axios.create({
  baseURL: appSettings.api.REACT_APP_API_HOST,
})

export const examsAPI = {
  getExams() {
    return instance.get<ExamCard[]>('exams').then(response => response.data)
  },
  getTasks(id: string) {
    return instance.get<Task[]>(`exams/${id}`).then(response => response.data)
  },
}
